<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-05-25 18:10:49
 * @LastEditors: liyong
 * @LastEditTime: 2022-06-20 14:09:54
 * @FilePath: /partner.chaoyongtuan.com/src/views/shopManage/orderDetails/list/components/updateOrderDialog/components/scaleDialog/index.vue
 * 
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved. 
-->
<template>
  <el-dialog :title="`修改${drName}分成比`" :visible.sync="dialogVisible" width="520px" :before-close="handleClose">
    <div class="content">
      <Tip content="仅对筛选结果订单修改分成比例，不影响员工其它订单的分成比例"></Tip>
      <el-form class="mt-24" :model="form" :rules="rules" ref="ruleForm" label-width="100px" hide-required-asterisk>
        <el-form-item label-width="120px" prop="scale">
          <template v-slot:label>
            <span class="flex flex-align-center">
              <span>达人分成比</span>
              <explain class="fz-14 yx-color-info ml-4" content="直接由达人分销产生的订单，员工应获得的分成比。提成金额=订单付款金额*推广商品服务费率*达人分成比" />
            </span>
          </template>
          <el-input-number v-model="form.scale" controls-position="right" :min="0" :max="100" />
          <span class="yx-color-text-primary ml-8 mr-24">%</span>
        </el-form-item>
        <el-form-item label-width="120px" prop="partner_scale">
          <template v-slot:label>
            <span class="flex flex-align-center">
              <span>团长分成比</span>
              <explain class="fz-14 yx-color-info ml-4" content="由团长分销产生的订单，员工应获得的分成比。提成金额=订单付款金额*推广商品服务费率*团长分成比" />
            </span>
          </template>
          <el-input-number v-model="form.partner_scale" controls-position="right" :min="0" :max="100" />
          <span class="yx-color-text-primary ml-8 mr-24">%</span>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit">确 认</el-button>
    </span>
  </el-dialog>
</template>
<script>
import explain from '@/components/common/explain'
import { drRoleType } from '@/utils/dataMap'

export default {
  components: {
    explain,
   
  },
  data() {
    return {
      form: {
        scale: '',
        partner_scale: ''
      },
      rules: {
        scale: { required: true, message: '请输入达人分成比', trigger: 'blur' },
        partner_scale: {required: true, message: '请输入团长分成比', trigger: 'blur' }
      },
      dialogVisible: false
    }
  },
  computed: {
    drName() {
      return drRoleType.name
    }
  },
  methods: {
    show({ scale = '', partner_scale = '' }) {
      this.form = {
        scale: +scale || 0,
        partner_scale: +partner_scale || 0
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.form = {
        scale: '',
        partner_scale: ''
      }
      this.dialogVisible = false
    },
    submit() {
      this.$refs.ruleForm.validate(async valid => {
        if(!valid) return
        this.$emit('setScale', this.form)
        this.handleClose()
      })
    }
  }
}
</script>

<style lang='less' scoped></style>
